import withHttp from '@/config/withHttp';
var baseURL = '/filemgr';
/* *************** 庭审中相关接口 ******************* */

var apis = {
  // 文件上传
  uploadFile: {
    url: '/web/file/case/uploadFile',
    method: 'post',
    isImport: true
  },
  deleteFile: {
    url: '/web/file/deleteById',
    method: 'post'
  },
  // 校验单个任务是否已完成
  checkFileTaskId: {
    url: '/web/file/checkFileTaskId',
    method: 'get'
  },
  // 校验多个任务是否已完成
  checkFileTaskIds: {
    url: '/web/file/checkFileTaskIds',
    method: 'get'
  }
};
export default withHttp(apis, baseURL);